import React from 'react';

import { Link, useLocation } from 'react-router-dom';

import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import classes from 'components/common/Tables/Cells/ActivityCell/ActivityCell.module.scss';

interface Props {
    activityName: string;
    isVirtual?: boolean;
    taskId: string | number;
    trackedUntrackedActionCell?: React.ReactNode;
    toggleRowSelected?: (value: boolean) => void;
    toggleAllRowsSelected?: (value: boolean) => void;
}

export const ActivityCell = ({
    activityName,
    isVirtual = true,
    trackedUntrackedActionCell,
    taskId,
    toggleRowSelected,
    toggleAllRowsSelected,
}: Props) => {
    const { pathname, search } = useLocation();

    const handleSelectRow = () => {
        if (toggleRowSelected && toggleAllRowsSelected) {
            toggleAllRowsSelected(false);
            toggleRowSelected(true);
        }
    };

    return (
        <div className={classes.ActivityCell}>
            <div className={classes.activityNameContainer}>
                <div
                    data-testid={'activity-name-link'}
                    className={classes.activityNameWrapper}
                    onClick={handleSelectRow}
                >
                    <CustomizedTooltip
                        tooltipContent={activityName}
                        triggerElement={
                            taskId ? (
                                <Link
                                    to={{
                                        pathname: `${pathname}/card-${taskId}${isVirtual ? '-1' : ''}`,
                                        search: search,
                                    }}
                                    className={classes.activityName}
                                >
                                    {activityName}
                                </Link>
                            ) : (
                                activityName
                            )
                        }
                    />
                </div>

                {trackedUntrackedActionCell}
            </div>
        </div>
    );
};
